import React from "react";
import { Link } from "react-router-dom";
import Icon from "../ui/icons";
import Logo from "../../assets/logo-mark.png";
import "./AuthShell.css";

const POINTS = [
  {
    icon: <Icon.Card />,
    title: "Print-accurate layout",
    body: "True CR80 geometry, real script rendering, exports at print resolution.",
  },
  {
    icon: <Icon.Image />,
    title: "Realistic photo mode",
    body: "Drop the card onto a surface with depth of field, grain and contact shadow.",
  },
  {
    icon: <Icon.Shield />,
    title: "Marked as a specimen",
    body: "Every number fails checksum validation. Previews carry a watermark.",
  },
];

/**
 * Shared frame for the sign-in and sign-up screens: a brand panel beside the
 * form rather than a lone card on an empty page.
 *
 * The brand half is decorative and is dropped below the tablet breakpoint,
 * where the form is the only thing worth the width.
 */
export default function AuthShell({ eyebrow, title, sub, children, footer }) {
  return (
    <main className="auth-split">
      <aside className="auth-brand" aria-hidden="true">
        <div className="auth-aurora" />
        <Link className="auth-brand-mark" to="/">
          <img src={Logo} alt="" />
          <span>
            FOL<span>IOX</span>
          </span>
        </Link>

        <div className="auth-brand-body">
          <h2>The Aadhaar-style card generator for layout work.</h2>
          <ul className="auth-points">
            {POINTS.map((p) => (
              <li key={p.title}>
                <span className="auth-point-icon">{p.icon}</span>
                <div>
                  <strong>{p.title}</strong>
                  <p>{p.body}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <p className="auth-brand-foot">
          Fictional data only. Not a government-issued document.
        </p>
      </aside>

      <section className="auth-panel">
        <div className="auth-panel-inner">
          <header className="auth-head">
            {eyebrow && <span className="auth-eyebrow">{eyebrow}</span>}
            <h1>{title}</h1>
            {sub && <p>{sub}</p>}
          </header>

          {children}

          {footer && <div className="auth-foot">{footer}</div>}
        </div>
      </section>
    </main>
  );
}
